import { PoolModelData } from "../model/approvalPoolModel";
import {
  ApprovalFlowDetailsData,
  ApprovalFlowGetData,
  ApprovalLevels,
} from "../model/approvalsFlowModel";

import { ApprovalFlowAction, FlowDialogMode } from "./approvalFlow.action";

export type ApprovalFlowState = {
  name: string;
  levels: ApprovalLevels[];
  isDefault: boolean;
  numLevels: number;
  activeTab:
    | "Approval Flow"
    | "Pool Names"
    | "Subscription"
    | "Credit Usage"
    | "Credit Alerts";
  approvalFlows: ApprovalFlowGetData[];
  pools: PoolModelData[];
  editingFlow?: ApprovalFlowGetData;
  detailedFlow?: ApprovalFlowDetailsData;
  isFlowDialogOpen?: boolean;
  loading: boolean;
  listLoading: boolean;
  deleteDialogOpen: boolean;
  deletingFlowId: string | null;
  dialogMode: FlowDialogMode;
  toast: {
    isVisible: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
};

export const approvalFlowInitialState: ApprovalFlowState = {
  name: "",
  levels: [],
  isDefault: false,
  loading: false,
  listLoading: false,
  numLevels: 0,
  approvalFlows: [],
  detailedFlow: undefined,
  dialogMode: "create",
  pools: [],
  editingFlow: undefined,
  isFlowDialogOpen: false,
  deleteDialogOpen: false,
  deletingFlowId: null,
  activeTab: "Approval Flow",
  toast: {
    isVisible: false,
    message: "",
    type: "success",
  },
};

export function approvalFlowReducer(
  state: ApprovalFlowState,
  action: ApprovalFlowAction,
): ApprovalFlowState {
  switch (action.type) {
    case "SET_NAME":
      return { ...state, name: action.payload };
    case "SET_LEVELS":
      return { ...state, levels: action.payload };
    case "SET_IS_DEFAULT":
      return { ...state, isDefault: action.payload };
    case "SET_NUM_LEVELS":
      return { ...state, numLevels: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "OPEN_DELETE_DIALOG":
      return {
        ...state,
        deleteDialogOpen: true,
        deletingFlowId: action.payload,
      };
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "CLOSE_DELETE_DIALOG":
      return {
        ...state,
        deleteDialogOpen: false,
        deletingFlowId: null,
      };

    case "UPDATE_LEVEL":
      return {
        ...state,
        levels: state.levels.map((lvl) =>
          lvl.id === action.id ? { ...lvl, ...action.updates } : lvl,
        ),
      };
    case "SET_EDITING_FLOW":
      return { ...state, editingFlow: action.payload };
    case "SET_FLOW_DIALOG_OPEN":
      return { ...state, isFlowDialogOpen: action.payload };
    case "SET_APPROVALS":
      return { ...state, approvalFlows: action.payload };
    case "SET_TOAST":
      return { ...state, toast: action.payload };
    case "HIDE_TOAST":
      return { ...state, toast: { ...state.toast, isVisible: false } };
    case "RESET":
      return { ...approvalFlowInitialState };
    case "SET_LIST_LOADING":
      return { ...state, listLoading: action.payload };
    case "SET_DIALOG_MODE":
      return { ...state, dialogMode: action.payload };
    case "SET_DETAILED_APPROVALS":
      return { ...state, detailedFlow: action.payload };

    default:
      return state;
  }
}
